interface Props {
  className?: string;
}

export default function SignupConsent({ className }: Props) {
  return (
    <div className={className}>
      <div className="text-sm text-muted-foreground">
        By clicking Continue, you create an account with Creso and agree to our{" "}
        <a
          target="_blank"
          className="font-semibold text-primary"
          href="https://creso.in/terms-and-conditions"
          rel="noreferrer"
        >
          Terms & Conditions.
        </a>
      </div>
    </div>
  );
}
